import styled from 'styled-components';

import { pickColor } from 'themes/helpers/pickColor';

const Layout = styled.div`
  display: flex;
  flex-direction: column;
  padding-left: ${({ theme }) => theme.sidebarWidth};

  min-height: 100vh;

  transition: padding-left ${({ theme }) => theme.transitionSpeed} linear;
`;

const Main = styled.main`
  flex: 2;
  padding: 2rem;
  background-color: ${pickColor('mainBackground')};
  position: relative;
`;

export { Layout, Main };
